import React from 'react';
import HorariosData from '../../Components/Admin/HorariosData/HorariosData';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import './Horarios.css';

export default function Horarios() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection horariosContainer'>
                <HeaderDash />
                <div className='horarios-container-wrapper'>
                    <HorariosData />
                </div>
            </section>
        </div>
    );
}

